import React from "react";

import { VotingHomeProps } from "./VotingHome";

const LazyVotingHomeComponent = React.lazy(() => import("./VotingHome").then((m) => ({ default: m.VotingHome })));

const LazyVotingHome: React.FC<VotingHomeProps> = (props) => <LazyVotingHomeComponent {...props} />;

export default LazyVotingHome;
